/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u45m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deliberate practice is focused, effortful practice on a specific weakness with feedback, rather than casual repetition of what you already do well. A 45-minute block is a practical length for one focused session before fatigue reduces the quality of the practice.`)
};

const es_timer_u45m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La práctica deliberada es una práctica enfocada y esforzada sobre una debilidad específica con retroalimentación, en lugar de la repetición casual de lo que ya haces bien. Un bloque de 45 minutos es una duración práctica para una sesión enfocada antes de que la fatiga reduzca la calidad de la práctica.`)
};

const de_timer_u45m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gezieltes Üben ist fokussiertes, anstrengendes Üben an einer bestimmten Schwäche mit Feedback, statt beiläufiger Wiederholung dessen, was du bereits gut kannst. Ein 45-Minuten-Block ist eine praktische Länge für eine fokussierte Session, bevor Ermüdung die Übungsqualität mindert.`)
};

const nl_timer_u45m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doelgerichte oefening is geconcentreerde, inspannende oefening op een specifieke zwakte met feedback, in plaats van achteloze herhaling van wat je al goed kunt. Een blok van 45 minuten is een praktische lengte voor één geconcentreerde sessie voordat vermoeidheid de kwaliteit van de oefening vermindert.`)
};

const fr_timer_u45m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La pratique délibérée est un entraînement concentré et exigeant sur une faiblesse précise, accompagné de retours, plutôt qu’une répétition machinale de ce que l’on maîtrise déjà. Un bloc de 45 minutes est une durée pratique pour une session concentrée, avant que la fatigue ne réduise la qualité de la pratique.`)
};

const it_timer_u45m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La pratica intenzionale è una pratica concentrata e impegnativa su una debolezza specifica con feedback, piuttosto che la ripetizione casuale di ciò che già si fa bene. Un blocco di 45 minuti è una durata pratica per una sessione concentrata prima che la fatica riduca la qualità della pratica.`)
};

const pt_br2_timer_u45m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prática deliberada é uma prática focada e esforçada em uma fraqueza específica, com feedback, em vez de repetição casual do que você já faz bem. Um bloco de 45 minutos é uma duração prática para uma sessão focada antes que a fadiga reduza a qualidade da prática.`)
};

const pt_timer_u45m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A prática deliberada é uma prática focada e esforçada sobre uma fraqueza específica, com feedback, em vez da repetição casual daquilo que já se faz bem. Um bloco de 45 minutos é uma duração prática para uma sessão focada antes de a fadiga reduzir a qualidade da prática.`)
};

const ja_timer_u45m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`意図的な練習とは、すでに得意なことを何となく繰り返すのではなく、フィードバックを受けながら特定の弱点に集中して努力を注ぐ練習のことです。45分のブロックは、疲労が練習の質を下げる前の、1回の集中セッションとして実用的な長さです。`)
};

const zh_timer_u45m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刻意练习是针对某项具体弱点、伴随反馈的专注且费力的练习，而不是随意重复你已经擅长的内容。45分钟是一次专注练习时段的实用时长，超过这个时长疲劳就会降低练习的质量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u45m_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u45m_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u45m_faq4_a", locale)
	if (locale === "en") return en_timer_u45m_faq4_a(inputs)
	if (locale === "es") return es_timer_u45m_faq4_a(inputs)
	if (locale === "de") return de_timer_u45m_faq4_a(inputs)
	if (locale === "nl") return nl_timer_u45m_faq4_a(inputs)
	if (locale === "fr") return fr_timer_u45m_faq4_a(inputs)
	if (locale === "it") return it_timer_u45m_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u45m_faq4_a(inputs)
	if (locale === "pt") return pt_timer_u45m_faq4_a(inputs)
	if (locale === "ja") return ja_timer_u45m_faq4_a(inputs)
	return zh_timer_u45m_faq4_a(inputs)
};